import './App.css';
import { NavbarTop } from './common_components/navbar_top';
import {AI_INTERVIEWER_BOASTING, AI_INTERVIEWER_BOASTING_GPT_5, BRR} from './common_components/common_ui_components'
import {LinkUI, LinkUIBasic, LinkUITealBold, LinkUITealBoldUnderlined} from './common_components/common_links'
import { txbb } from './common_components/text_style_components';
import { DSAInterviewSetsTable, DSASetsLinkHomePage } from './dsa/all_interview_sets';
import { RoadmapsLinkHomePage } from './other_pages/company_roadmaps';
import AllQuestionsTable from './questions_list/all_question_table';
import { ConnectAndBook } from './common_components/connect_and_book';

function App() {
  return (
    <div className="App">
      <NavbarTop />
      <div className="mt-20 flex flex-col w-full items-center  justify-center">
        <br />
        {  
      <h1 className='text-gray-700 text-3xl font-bold leading-10 py-4'>
        <span className=""> Practice LLD Interview Questions 
          </span><br />
    {  <span className=" py-4  "> 
        With AI Coach </span>
    }
      </h1>
  }
     {   false &&
      <h1 className='text-gray-700 text-2xl font-bold leading-10 py-4'>
        <span className=""> Practice Mock Interviews with AI Interviewer 
          </span><br />
    {  <span className="   "> 
        Low-Level Design and DSA Rounds </span>
    }
      </h1>
  }
      
    { false && <div className='text-left'>
      <BRR /> <br />
        <a className=' text-teal-600 font-bold  underline'
        href='/dsa/'>
          Data Structures and Algorithms AI Mock Interview Sets</a>

      </div>
    }
    {
      <div className='flex flex-row-responsive leading-8 items-center justify-center'> 
        <DSASetsLinkHomePage />  &nbsp;  &nbsp;
        <RoadmapsLinkHomePage />
      </div>
    }
      <br />
      {<div>
       <AllQuestionsTable /> 
      </div>
       }
    
     <br /> 
     <AI_INTERVIEWER_BOASTING_GPT_5 />
     <br /><br />
    

    { false &&
      <div className="flex flex-col justify-center items-center
       m-4 p-4 px-8 border-2 rounded-xl leading-10  text-gray-600 ">
        <span className="text-gray-600 font-bold text-xl">
          Coming soon ... </span> 
        <span className="text-teal-600 font-bold"> 
          DS & Algo Mock Interview Rounds with AI Interviewer </span> 
      And more Low Level Design Questions  

      </div>
    }   

<ConnectAndBook />

<div className='text-center text-gray-800'>
<br />
 Follow us on 
 <LinkUI url="https://www.youtube.com/@CodeZym/videos" text="YouTube" /> 
 and 
 <LinkUI url="https://medium.com/@prashant558908" text="Medium" /> 
  for  blogs and video tutorials. <BRR />
  Ask us any question on our reddit group 
          { LinkUI({url : "https://www.reddit.com/r/LowLevelDesign/", 
                          text : "r/LowLevelDesign"}) } <br />

  { 
  //We will help you clear DS & Algo and low level design interviews.
  }
</div>
<div className="text text-gray-800 text-center mx-6 md:mx-0">
  <br /> Reach us at : &nbsp; 
<span className=" font-semibold text-teal-700">contact@codezym.com</span>
<br />

</div>
<div className='flex flex-row-responsive items-center justify-center '>
  <LinkUI url="/terms" text="Terms and Conditions" />
  &nbsp; 
  <LinkUI url="/privacy" text="Privacy Policy" />
  &nbsp; 
  <LinkUI url="/refunds" text="Refunds and Cancellation Policy" />
</div>

<br /><br />   
        
        </div>
    </div>
  );
}

export default App;
